import React from "react";
import NEMTShell from "./nemt-hub-unified";

export default function App() {
  return <NEMTShell />;
}
